import React, { useContext } from 'react';

import styled from '@emotion/styled';

import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface ReviewModalProps {
  data: any;
}

const ReviewModal: React.FC<ReviewModalProps> = ({ data }) => {
  const modalContext = useContext(ModalContext);

  return (
    <ModalContainer
      width={!modalContext?.showSuccessComponent ? '520px' : undefined}
      removeCloseIcon={true}
    >
      <Container>
        <HeaderArea>{data?.companyName ?? ''}</HeaderArea>
        <DateArea>
          {data?.startDate ?? ''} <span>&mdash;</span> {data?.endDate ?? ''}
        </DateArea>
        <Blockquote>
          <BlockHeader>Exit Review</BlockHeader>
          <BlockBody>
            <Paragraph>"{data?.exitReview}"</Paragraph>
            <cite
              style={{
                fontSize: '14px',
                fontWeight: 400,
              }}
            >
              — {data?.reviewer ?? ''}
            </cite>
          </BlockBody>
        </Blockquote>
        <CloseModalButton onClick={() => modalContext?.setShowModal(false)}>
          Done
        </CloseModalButton>
      </Container>
    </ModalContainer>
  );
};

export default ReviewModal;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const HeaderArea = styled.div`
  font-weight: 700;
  font-size: 20px;
  color: #2f3644;
`;

const Blockquote = styled.blockquote`
  width: 100%;
  grid-column: span 3;
  background-color: #fafafa;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 28px;
`;

const BlockHeader = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #6e7079;
`;

const BlockBody = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Paragraph = styled.p`
  font-weight: 600;
  font-size: 16px;
  color: #2f3644;
`;

const DateArea = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #6e7079;
`;

const CloseModalButton = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  font-size: 14px;
  padding: 14px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: 28px;
  border-radius: 8px;
`;
